import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  effect,
  inject,
  signal,
  viewChild
} from '@angular/core';
import { MatButton, MatMiniFabButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ui-file-dialog',
  imports: [MatDialogModule, MatButton, MatMiniFabButton, MatIcon],
  templateUrl: './file-dialog.component.html',
  styleUrl: 'file-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileDialogComponent implements OnInit, OnDestroy {
  public readonly zoomContainer = viewChild<ElementRef<HTMLElement>>('zoomContainer');
  private readonly sanitizer = inject(DomSanitizer);
  private readonly file = inject<Blob>(MAT_DIALOG_DATA);

  protected isImage = false;
  protected safeUrl?: SafeResourceUrl;
  protected zoom = signal(1);

  private fileUrl?: string;
  private imageTypes = ['image/avif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/webp'];

  constructor() {
    effect(() => {
      const zoomContainer = this.zoomContainer();
      if (zoomContainer === undefined) return;

      const zoomElem = zoomContainer.nativeElement;
      zoomElem.addEventListener('pointerdown', (event) => {
        zoomElem.setPointerCapture(event.pointerId);
        zoomElem.style.cursor = 'grabbing';
      });
      zoomElem.addEventListener('pointerup', (event) => {
        zoomElem.releasePointerCapture(event.pointerId);
        zoomElem.style.cursor = 'grab';
      });
      zoomElem.addEventListener('pointermove', (event) => {
        if (zoomElem.hasPointerCapture(event.pointerId)) {
          zoomElem.scrollLeft -= event.movementX;
          zoomElem.scrollTop -= event.movementY;
        }
      });
      zoomElem.addEventListener(
        'wheel',
        (event) => {
          event.preventDefault();
          event.deltaY > 0 ? this.zoomOut() : this.zoomIn();
        },
        { passive: false }
      );
    });
  }

  public ngOnInit(): void {
    this.isImage = this.imageTypes.includes(this.file.type);
    this.fileUrl = URL.createObjectURL(this.file);
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);
  }

  public ngOnDestroy(): void {
    if (this.fileUrl) {
      URL.revokeObjectURL(this.fileUrl);
    }
  }

  protected zoomIn(): void {
    this.zoom.update((current) => Math.min(5, current + 0.2));
  }

  protected zoomOut(): void {
    this.zoom.update((current) => Math.max(0.2, current - 0.2));
  }
}
